module.exports = __webpack_public_path__ + "img/atl-bg.81be794e.png";